import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { getCategoryName } from '@/utils/content';

export default function TickerBar() {
  const items = articles.slice(0, 6);
  const loop = [...items, ...items];

  return (
    <section aria-label="最新反转速报" className="border-y border-background-300 bg-background-100">
      <div className="mx-auto flex w-full items-center gap-4 px-4 py-3 md:px-6">
        <span className="flex shrink-0 items-center gap-2 rounded-full bg-primary-500 px-3 py-1.5 text-xs font-semibold font-label text-background-50">
          <span className="h-1.5 w-1.5 animate-pulseSoft rounded-full bg-background-50" />
          反转速报
        </span>
        <div className="group relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-8 group-hover:[animation-play-state:paused]">
            {loop.map((item, index) => (
              <Link
                key={`${item.id}-${index}`}
                to={`/article/${item.id}`}
                className="flex shrink-0 items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-700"
              >
                <span className="text-xs font-label text-primary-600">{item.publishDate}</span>
                <span className="whitespace-nowrap">{item.title}</span>
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-label text-secondary-800">
                  {getCategoryName(item.category)}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}